import { pubSub } from '@utils/PubSub';

function updateFromDY(message) {
  let copy = document.querySelector('.pdp-notification__copy');
  if (!copy) return;
  copy.textContent = message;

  initNotification();
}

function listenClose() {
  let notification = document.querySelector('.pdp-notification');
  let close = document.querySelector('.pdp-notification__close');
  if (!notification || !close) return;

  close.addEventListener('click', () => {
    notification.removeAttribute('active', '');
    window.sessionStorage.setItem('pdp-notification-visible', 'false');
  });
}

function initNotification() {
  let notification = document.querySelector('.pdp-notification');
  const notificationVisibility = window.sessionStorage.getItem('pdp-notification-visible') ?? 'true';
  const userOptedOut = notificationVisibility === 'false';
  if (!notification || userOptedOut) return;

  let delay = parseInt(notification.dataset.delay);
  setTimeout(() => {
    notification.setAttribute('active', '');
  }, delay);

  listenClose();
}

function mountPdpNotification() {
  pubSub.subscribe(`dy:pdp-tote-popup:init`, () => {
    let message = window.Brooklinen.pdpTotePopup[0].popup_content;
    updateFromDY(message);
    pubSub.unsubscribe(`dy:pdp-tote-popup:init`);
  });

  if (!window.Brooklinen.pdpTotePopup) initNotification();
}

mountPdpNotification();
